import React from "react";
import { Formik, Field, FieldArray, Form as FormikForm } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

export default function ParametersForm({ params, onSubmit, ...props }) {
  const { addToast } = useToasts();
  function validate(key, values) {
    const errors = {};
    if (!values[key] || !values[key].length) {
      errors[key] = "Must be specified";
      addToast(`${key} can not be empty`, { appearance: "error" });
    }
    return errors;
  }

  /**
   * example format for params:
   * (2) [Array(2), Array(2)]
   *  0: Array(2)
   *      0: "follows"
   *      1: {descr: "The list of Twitter user ids to follow", title: "Follows", editable: true, values: Array(9)}
   *  1: Array(2)
   *      0: "languages"
   *      1: {descr: "The list of languages to fetch the tweets in", title: "Languages", editable: true, values: Array(1)}
   */
  function parameterFormRow(param) {
    if (param[1].editable) {
      if (param[1].values instanceof Array) {
        const configValues = [...param[1].values];
        return (
          <Card key={`card_${param[0]}`} className="mb-2">
            <Card.Body>
              <div className="text-uppercase font-weight-bold">{param[0]}</div>
              <div className="small pt-1 pb-2 font-italic ">
                {param[1].descr}
              </div>
              <Formik
                validate={(values) => {
                  return validate(param[0], values);
                }}
                initialValues={{ [param[0]]: configValues }}
                onSubmit={(values) => onSubmit(values)}
              >
                {({ values }) => (
                  <FormikForm>
                    <FieldArray
                      name={param[0]}
                      render={(arrayHelpers) => (
                        <div>
                          {values[param[0]] && values[param[0]].length > 0 ? (
                            values[param[0]].map((val, index) => (
                              <div key={index} className="form-group row">
                                <Field
                                  name={`${param[0]}.${index}`}
                                  className="col form-control"
                                />
                                <button
                                  className="btn btn-light btn-sm"
                                  onClick={() => arrayHelpers.remove(index)} // remove an item from the list
                                >
                                  <FontAwesomeIcon icon="minus" />
                                </button>
                                <button
                                  className="btn btn-light btn-sm"
                                  onClick={() => arrayHelpers.insert(index, "")} // insert an empty string at a position
                                >
                                  <FontAwesomeIcon icon="plus" />
                                </button>
                              </div>
                            ))
                          ) : (
                            <button
                              className="btn btn-info mb-1"
                              onClick={() => arrayHelpers.push("")}
                            >
                              {/* show this when user has removed all items from the list */}
                              Add a value
                            </button>
                          )}
                          <div>
                            <button
                              className="btn btn-dark float-right"
                              type="submit"
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      )}
                    />
                  </FormikForm>
                )}
              </Formik>
            </Card.Body>
          </Card>
        );
      } else {
        //TODO implement later
        //assume string (deal with boolean later)
      }
    } else {
      return null;
    }
  }

  return (
    <div>
      <h5>Editable parameters:</h5>
      {params.map((p) => {
        return parameterFormRow(p);
      })}
    </div>
  );
}
